import request from '@/utils/request'

// 查询文件存储列表
export function listFileStorage(query = {}) {
  return request({
    url: `/file/fileStorage/list?pageNum=${query.pageNum}&pageSize=${query.pageSize}`,
    method: 'post',
    data: query
  })
}

// 查询文件存储详细
export function getFileStorage(fileId) {
  return request({
    url: '/file/fileStorage/info/' + fileId,
    method: 'get'
  })
}

// 新增文件存储
export function addFileStorage(data) {
  return request({
    url: '/file/fileStorage/add',
    method: 'post',
    data: data
  })
}

// 修改文件存储
export function updateFileStorage(data) {
  return request({
    url: '/file/fileStorage/edit',
    method: 'put',
    data: data
  })
}

// 删除文件存储
export function delFileStorage(fileId) {
  return request({
    url: '/file/fileStorage/remove/' + fileId,
    method: 'delete'
  })
}
